import LandingFooter from '@/modules/Pages/shared/LandingFooter';
import LandingNav from '@/modules/Pages/shared/LandingNav';
import LandingReveal from '@/modules/Pages/shared/LandingReveal';
import '@/modules/Pages/shared/landingPage.css';

import WaitlistWizard from './WaitlistWizard';

/**
 * Early-access waitlist survey — one question per slide.
 * Structure from "ChurnSignal - waiting list" copy doc.
 */
export default function WaitlistPage() {
  return (
    <div className="landing-page landing-grain min-h-screen font-sans relative">
      <div className="relative z-10">
        <LandingNav />
        <main className="pt-32 pb-24 px-6">
          <div className="max-w-2xl mx-auto">
            <LandingReveal className="text-center mb-10">
              <p className="landing-section-label mb-4">Early access</p>
              <h1 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-4">
                ChurnSignal waitlist for early access
              </h1>
              <p className="landing-prose">
                We&apos;re opening ChurnSignal to a small group of B2B SaaS teams.
              </p>
            </LandingReveal>

            <LandingReveal delayClass="landing-delay-1">
              <WaitlistWizard />
            </LandingReveal>
          </div>
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
